/* © CNES */
import { Slider, SliderChangeEvent } from 'primereact/slider';
import { useEffect, useState } from 'react';
import { SliderValuesProps } from '../../Filters';
import './InnerSlider.scss';

/**
 * Inner Slider Props.
 */
export interface InnerSliderProps {
  handleChange: (e: any) => void;
  sliderSectionParam: string;
  sliderValues: SliderValuesProps;
  setSliderValues: (e: any) => void;
  sliderPosition: number;
}

/**
 * Inner Slider.
 * @param handleChange Function to handle change when slider is moved.
 * @returns InnerSlider Element.
 */
export const InnerSlider = ({
  handleChange,
  sliderSectionParam,
  sliderValues,
  setSliderValues,
  sliderPosition,
}: InnerSliderProps) => {
  /**
   * Initialize values for the slider.
   */
  const [initValues, setInitValues] = useState<number[]>(
    sliderValues.sliderTable.find((el) => el.param === sliderSectionParam)
      ?.values as number[]
  );

  /**
   * Set the id for the slider handles when the component mounts.
   */
  useEffect(() => {
    const handleStart = document.querySelectorAll('.p-slider-handle-start')[
      sliderPosition
    ];
    const handleEnd = document.querySelectorAll('.p-slider-handle-end')[
      sliderPosition
    ];
    if (handleStart) {
      handleStart.setAttribute('id', `${sliderSectionParam}-start`);
      handleEnd.setAttribute('id', `${sliderSectionParam}-end`);
    }
  });

  /**
   * Move slider handles depending on current value.
   */
  useEffect(() => {
    const handleStart = document.getElementById(`${sliderSectionParam}-start`);
    const handleEnd = document.getElementById(`${sliderSectionParam}-end`);

    if (handleStart && handleEnd) {
      handleStart.innerHTML = `<div class="
      percentNumber positionLeft fontSlider
        ">${
          sliderValues.sliderTable.find((el) => el.param === sliderSectionParam)
            ?.values[0]
        }%</div>`;

      handleEnd.innerHTML = `<div class="
      percentNumber positionRight fontSlider
        ">${
          sliderValues.sliderTable.find((el) => el.param === sliderSectionParam)
            ?.values[1]
        }%</div>`;
    }
  }, [sliderValues, sliderSectionParam, sliderPosition]);

  /**
   * onValueChange when user moves handles.
   * @param event SliderChangeEvent.
   */
  const onChange = (event: SliderChangeEvent) => {
    setInitValues(event.value as number[]);

    setSliderValues({
      isInitialisation: false,
      sliderTable: sliderValues.sliderTable.map((el) =>
        el.param === sliderSectionParam
          ? { ...el, values: event.value as number[] }
          : el
      ),
    });
  };

  /**
   * onSlideEnd when user stop moving handles.
   * @param event SliderChangeEvent.
   */
  const onSlideEnd = (event: SliderChangeEvent) => {
    handleChange(event.value);
  };

  return (
    <div className="slider">
      <div className="rangeSlider">
        <span className="minSlider fontSlider">0%</span>
        <span className="maxSlider fontSlider">100%</span>
      </div>
      <div className="sliderBar">
        <Slider
          value={initValues as number | [number, number] | undefined}
          onChange={onChange}
          className="slider"
          range
          onSlideEnd={onSlideEnd}
        />
      </div>
    </div>
  );
};
